export default {
  buttons: {
    create: 'Créer',
    update: 'Mettre à jour',
    cancel: 'Annuler',
  },
  fields: {
    title: {
      label: 'Titre',
      placeholder: 'Saisir le titre',
    },
    description: {
      label: 'Description',
      placeholder: 'Saisir la description',
    },
    button_text: {
      label: 'Texte du bouton',
      placeholder: 'Saisir le texte du bouton',
    },
    button_url: {
      label: 'URL du bouton',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Image',
    },
  },
  title: 'Créer un post',
};
